import script from "./adjust.vue?vue&type=script&setup=true&lang=js"
export * from "./adjust.vue?vue&type=script&setup=true&lang=js"

import "./adjust.vue?vue&type=style&index=0&id=f65b5d60&scoped=true&lang=css"

import exportComponent from "/jenkins/workspace/h-waterwork-storeroom-webui_prev/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f65b5d60"]])

export default __exports__